
import BarChart from './BarChart';
import ChartBase from './ChartBase';

export default {
  i18nComponentKey: 'WidgetProductReviewsStatistics.components.ChartMobile',
  name: 'ChartMobile',
  components: { BarChart },
  extends: ChartBase
};
